/** Shared flow-field presets — smooth lens math, no discontinuous sign flips. */

export const FLOW_PRESETS = {
  hero: {
    flowW: 1600,
    flowH: 760,
    count: 30,
    gap: 27,
    startBase: -40,
    cxBase: 540,
    cxAmp: 70,
    cyBase: 330,
    cyAmp: 34,
    xStep: 38,
    gaussSigma: 280,
    lensSoftness: 64,
    lensRange: 400,
    swayBase: 80,
    swayAmp: 16,
    opacityCenter: 2.2,
  },
  cta: {
    flowW: 1600,
    flowH: 620,
    count: 26,
    gap: 26,
    startBase: -30,
    cxBase: 800,
    cxAmp: 90,
    cyBase: 310,
    cyAmp: 30,
    xStep: 40,
    gaussSigma: 320,
    lensSoftness: 64,
    lensRange: 360,
    swayBase: 72,
    swayAmp: 15,
    opacityCenter: 2,
  },
};

function smoothLensOffset(base, cy, gauss, sway, softness, range) {
  const offset = base - cy;
  const envelope = Math.exp(-Math.pow(offset / range, 2));
  return (offset / softness) * gauss * sway * envelope;
}

export function buildStreamlinePath(i, t, presetKey = 'hero') {
  const cfg = FLOW_PRESETS[presetKey] ?? FLOW_PRESETS.hero;
  const {
    flowW,
    gap,
    startBase,
    cxBase,
    cxAmp,
    cyBase,
    cyAmp,
    xStep,
    gaussSigma,
    lensSoftness,
    lensRange,
    swayBase,
    swayAmp,
  } = cfg;

  const base = startBase + i * gap;
  const cx = cxBase + Math.sin(t * 0.16) * cxAmp;
  const cy = cyBase + Math.cos(t * 0.12) * cyAmp;
  const sway = swayBase + Math.sin(t * 0.3 + i * 0.22) * swayAmp;
  const pts = [];

  for (let x = -80; x <= flowW + 80; x += xStep) {
    const phase = t * 0.35 + i * 0.16;
    const wave =
      Math.sin((x / flowW) * Math.PI * 1.5 + phase) * 17 +
      Math.sin((x / flowW) * Math.PI * 3.1 + phase * 1.4) * 6;
    const dx = x - cx;
    const gauss = Math.exp(-(dx * dx) / (2 * gaussSigma * gaussSigma));
    const lens = smoothLensOffset(base, cy, gauss, sway, lensSoftness, lensRange);
    pts.push([x, base + wave + lens]);
  }

  return `M ${pts.map((p) => `${p[0].toFixed(2)} ${p[1].toFixed(2)}`).join(' L ')}`;
}

export function lineOpacity(i, presetKey = 'hero') {
  const { count, opacityCenter } = FLOW_PRESETS[presetKey] ?? FLOW_PRESETS.hero;
  return 0.45 + 0.55 * Math.exp(-Math.abs(i - count / opacityCenter) / 8);
}
